module.exports = __webpack_public_path__ + "img/oilbg.81d22c47.jpg";